/*require('./../style/scrollbar.less');*/
require('../utils/requestAnimationFrame');
var Component=require('./Component');
var $ = require('jQuery');
var template=require('../template/scrollbar.html');

// 动画时间
var duration = 38;

// 获取窗口高度
var getWindowHeight = function () {
    if (this._windowheight > 0)
        return this._windowheight;

    this._windowheight = this._window.outerHeight();
    return this._windowheight;
};

// 滚动,设置scrolltop的值
var setScrolltop = function (scrolltop, content_animate, wheel_animate) {
    var contentheight = this._content.outerHeight();
    var windowheight = getWindowHeight.call(this);

    // 设置content的位置
    // 防止越界
    var max = contentheight - windowheight;
    scrolltop = scrolltop <= max ? scrolltop : max;
    scrolltop = scrolltop >= 0 ? scrolltop : 0;

    if (content_animate) {
        this._content.stop().animate({
            'marginTop': -scrolltop + 'px'
        }, duration);
    }
    else {
        this._content.stop().css({
            'margin-top': -scrolltop + 'px'
        });
    }

    // 设置scrollbar的位置
    var topratio = scrolltop / (contentheight - windowheight);
    var wheeltop = (1 - this._wheelheight) * topratio;
    if (wheel_animate) {
        this._wheel.stop().animate({
            'top': wheeltop * 100 + '%'
        }, duration);
    }
    else {
        this._wheel.stop().css({
            'top': wheeltop * 100 + '%'
        });
    }
    this.triggerEvent('scrolled', scrolltop);
};

var Scrollbar = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            window: null,
            content: null
        };
        $.extend(defaults, options);
        Component.call(self, defaults);

        self._windowheight = 0;
        self._minwheelheight = 0;
        self._wheelheight;
        self._window = self._options.window;
        self._content = self._options.content;
        self._rail = self._element.find('.im-scrollbar-rail');
        self._wheel = self._element.find('.im-scrollbar-wheel');
    })(this);

    // 显示&隐藏滚轮
    (function (self) {
        self._window.mouseenter(function () {
            self._element.addClass('im-hover');
        });
        self._window.mouseleave(function () {
            self._element.removeClass('im-hover');
        });
    })(this);

    // 鼠标拖拽
    (function (self) {
        var lastPageY;

        var drag = function (event) {
            if (lastPageY === null) {
                lastPageY = event.pageY;
                return;
            }

            var deltaY = event.pageY - lastPageY;
            // console.log(deltaY);
            var railheight = self._rail.height();
            var contentheight = self._content.outerHeight();
            var distance = contentheight * deltaY / railheight;
            self.scroll(distance, false, false);
            lastPageY = event.pageY;

            event.preventDefault();
        };

        self._wheel.mousedown(function () {
            lastPageY = null;
            var heightofrail = self._rail.outerHeight();
            var contentheight = self._content.outerHeight();
            $(window).bind('mousemove', drag);
            self._window.addClass('im-scrolling');
            self._element.addClass('im-draging');
        });

        $(window).mouseup(function () {
            $(window).unbind('mousemove', drag);
            self._window.removeClass('im-scrolling');
            self._element && self._element.removeClass('im-draging');
        });
    })(this);

    // 鼠标滚轮
    (function (self) {
        self._window.mousewheel(function (event) {
            window.requestAnimationFrame(function(){
              self.scroll(-event.deltaFactor * event.deltaY, false, false);
            });
            event.preventDefault();
        });
    })(this);
};
Scrollbar.prototype = Object.create(Component.prototype);
Scrollbar.prototype.init = function () {
    // this._windowheight = this._window.outerHeight();
    this._minwheelheight = 0.5;
    this._element && this._element.addClass('im-inited');
};
Scrollbar.prototype.calHeight = function () {
    var contentheight = this._content.outerHeight();
    var windowheight = getWindowHeight.call(this);
    if (contentheight <= windowheight)
        return;
    var height = windowheight / contentheight;
    height = height >= this._minwheelheight ? height : this._minwheelheight;
    this._wheel.css({
        'height': height * 100 + '%'
    });
    this._wheelheight = height;
};
/*Scrollbar.prototype.getScrolltop = function () {
    var margintop = this._content.css('margin-top');
    return -parseFloat(margintop);
};*/
/*
 * 滚动。distance>0，滚动条往下；distance小于0，滚动条往上
 */
Scrollbar.prototype.scroll = function (distance, content_animate, wheel_animate) {
    var margintop = this._content.css('margin-top');
    var scrolltop = -parseFloat(margintop);
    setScrolltop.call(this, scrolltop + distance, content_animate, wheel_animate);
};
Scrollbar.prototype.scrollToTop = function (content_animate, wheel_animate) {
    setScrolltop.call(this, 0, content_animate, wheel_animate);
};
Scrollbar.prototype.scrollToBottom = function (content_animate, wheel_animate) {
    var contentheight = this._content.outerHeight();
    var windowheight = getWindowHeight.call(this);
    if (contentheight > windowheight) {
        setScrolltop.call(this, contentheight - windowheight, content_animate, wheel_animate);
    }
};
Scrollbar.prototype.resetWindowHeight = function () {
    this._windowheight = this._window.outerHeight();
};

module.exports = Scrollbar;
